import { TableCell, TableRow } from "@mui/material";
import { memo } from "react";

import { type RoleEntity, type RoleEntityRules } from "@/modules/roles/types";

import { ROLES_TABLE_DATA_COLUMNS } from "./constants";
import { RolesTableCell } from "./RolesTableCell";

export type EntityRulesCheckMap = Record<keyof RoleEntityRules, boolean>;

type RolesTableRowProps = {
  entity: RoleEntity;
  isDisabled?: boolean;
  onChange?: (ruleToChange: string, isChecked: boolean) => void;
} & EntityRulesCheckMap;

export const RolesTableRow = memo(
  ({ entity, isDisabled, onChange, ...checkMap }: RolesTableRowProps) => {
    return (
      <TableRow key={entity.name}>
        <TableCell key="entityName">{entity.name}</TableCell>
        {ROLES_TABLE_DATA_COLUMNS.map((column) => {
          const ruleName = entity.rules[column];
          const isRuleDisabled = !ruleName || isDisabled;
          const isChecked = Boolean(ruleName) && checkMap[column];

          return (
            <RolesTableCell
              key={column}
              name={ruleName || undefined}
              isDisabled={isRuleDisabled}
              isChecked={isChecked}
              onChange={onChange}
            />
          );
        })}
      </TableRow>
    );
  },
);

RolesTableRow.displayName = "RolesTableRow";
